import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Switch,
  DialogContentText,
  LinearProgress
} from '@material-ui/core'
import ContractFormComponent from '../../components/employer/lightEntrepreneurs/contractForm.component'
import { CloseIcon } from '../../components/openforwork/closeIcon.component'

const ContractFormDialog = ({
  classes,
  t,
  isOpen,
  title,
  subtitle,
  copyPrevious,
  handleSwitchChange,
  cancelOffer,
  formSubmit,
  setCopyPrevious,
  openWarningCloseCompleteOfferForm,
  closeWarningCloseCompleteOfferForm,
  openWarningCloseCompleteForm,
  formLocation,
  showLeItemLoader,
  previewAssignment,
  enableSendOrSignButton,
  signAndSendContract,
  loadSignAndSend,
  isSigned = false,
  assignmentFormValues,
  addNewAssignment, // add new assignment then offer the data base on assignment
  offerFromLightEntre
}) => {
  const label = { inputProps: { 'aria-label': 'Switch demo' } }
  return (
    <div>
      {' '}
      <Dialog
        open={isOpen}
        BackdropProps={{
          classes: { root: 'dialog-backdrop' },
          style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="md"
      >
        <CloseIcon
          fontSize="large"
          onClick={() => openWarningCloseCompleteOfferForm()}
        />
        <DialogTitle id="alert-dialog-title">
          <div
            style={{ textAlign: 'center', color: '#000000', fontSize: '15px' }}
          >
            {title}
          </div>
          <div style={{ color: '#0000008A', textAlign: 'center' }}>
            <p style={{ fontSize: '14px' }}>
              <Switch
                checked={copyPrevious}
                onChange={handleSwitchChange}
                {...label}
              />{' '}
              {subtitle}
            </p>
          </div>
        </DialogTitle>
        <DialogContent>
          <div>
            <ContractFormComponent
              cancelOffer={cancelOffer}
              formSubmit={formSubmit}
              setCopyPrevious={setCopyPrevious}
              openWarningCloseCompleteOfferForm={
                openWarningCloseCompleteOfferForm
              }
              closeWarningCloseCompleteOfferForm={
                closeWarningCloseCompleteOfferForm
              }
              openWarningCloseCompleteForm={openWarningCloseCompleteForm}
              formLocation={formLocation}
              showLeItemLoader={showLeItemLoader}
              previewAssignment={previewAssignment}
              signAndSendContract={signAndSendContract}
              enableSendOrSignButton={enableSendOrSignButton}
              assignmentFormValues={assignmentFormValues}
              addNewAssignment={addNewAssignment}
              offerFromLightEntre={offerFromLightEntre}
            />
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        open={loadSignAndSend}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        BackdropProps={{
          // Set the background color of the dialog
          classes: {
            root: classes.root
          },
          style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' }
        }}
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ fontSize: '15px', margin: '20px' }}
          >
            {!isSigned
              ? t('employer.app.dialogContent2')
              : t('employer.app.dialogContent3')}
          </DialogContentText>
        </DialogContent>
        <div className={classes.progress}>
          <LinearProgress />
        </div>
      </Dialog>
    </div>
  )
}

export default ContractFormDialog
